import { Question } from '../types';

/**
 * A question is playable when all 4 options are non-empty and `respuesta`
 * exactly matches (whitespace-trimmed) one of them - mirroring the same
 * trim-based comparison `pressResolve` uses to grade an answer.
 */
export const isValidQuestion = (question: Question): boolean => {
  const options = [question['1'], question['2'], question['3'], question['4']];
  if (options.some((option) => !option || option.trim() === '')) {
    return false;
  }

  const trimmedOptions = options.map((option) => option.trim());
  const correctAnswer = (question.respuesta || '').trim();
  return trimmedOptions.includes(correctAnswer);
};

/**
 * Splits questions into playable ones and invalid ones, warning to the
 * console for each invalid row so a sheet data-entry error is discoverable
 * instead of silently producing an unwinnable question.
 */
export const partitionValidQuestions = (questions: Question[]): Question[] => {
  return questions.filter((question) => {
    const valid = isValidQuestion(question);
    if (!valid) {
      console.warn(
        `[useQuestions] Question id="${question.id}" is missing an option or its "respuesta" doesn't match any of the 4 options exactly. Excluded from the playable pool.`
      );
    }
    return valid;
  });
};
